import FullBleedPageContainer from '@/common/components/FullBleedPageContainer';
import { useAppContext } from '@/common/hooks/AppStateProvider';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';
import HarnessInstance from '../components/HarnessInstance';

const Harness = () => {
  const { organizationId } = useOrganizationPath();
  const { session } = useAppContext();
  return (
    <FullBleedPageContainer>
      <HarnessInstance key={`${organizationId}:${session.user.id}`} />
    </FullBleedPageContainer>
  );
};
export default Harness;
